import { APCOA_EI_TENANT_IDS } from '@debbie/common/dist/bespoke/apcoa/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { validateNewUserOnCustomer, } from '@debbie/common/dist/customers/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { Lang } from '@debbie/common/dist/lang/Lang.js';
import { isCaseworker } from '@debbie/common/dist/permissions/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as casesAPI from '@debbie/cortex/dist/api/cases.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { casesEntity, ensureCaseLoaded, useCase, } from '@debbie/cortex/dist/cases/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { customersEntity, ensureCustomerLoaded, useCustomer, } from '@debbie/cortex/dist/customers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant, useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../../utils/errors.js';
import Alert from '../Alert.js';
import APCOAAddDMRUser from '../bespoke/APCOA/APCOAAddDMRUser.js';
import Button from '../Button.js';
import ButtonIcon from '../ButtonIcon.js';
import CopyToClipboard from '../CopyToClipboard.js';
import { Edit, Globe, Link2, Repeat, User } from '../Icons/index.js';
import Input from '../Input.js';
import Modal from '../Modal.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import CreateUserOnCustomer, { getNewUser } from './CreateUserOnCustomer.js';
import UserOnCustomer from './UserOnCustomer.js';
const CustomerPreview = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const customerLoader = useCustomer(props.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const creditorLoadable = useCreditor(customer?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const meRole = useRole();
    const singleCaseLoadable = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoadable)
        ? singleCaseLoadable.data
        : null;
    const site = useSelector((s) => s.site);
    const tenantId = useTenantId();
    const [addCustomerModalOpen, setAddCustomerModalOpen] = useState(false);
    const [editReferenceIdModalOpen, setEditReferenceIdModalOpen] = useState(false);
    const [referenceId, setReferenceId] = useState('');
    const [isCompany, setIsCompany] = useState(null);
    const [newUser, setNewUser] = useState(null);
    useEffect(() => {
        if (customer) {
            setReferenceId(customer.referenceId || '');
            setIsCompany(customer.isCompany);
        }
    }, [customer]);
    // Mutation for saving reference ID
    const saveReferenceIdMutation = useMutation(async (_referenceId) => {
        if (!customer) {
            throw new Error('No customer');
        }
        await customersAPI.patch(customer.customerId, {
            referenceId: _referenceId || null,
        });
        q.invalidate(keys.write.modify(customersEntity, customer.customerId));
        await ensureCustomerLoaded(customer.customerId);
    }, {
        onSuccess: () => {
            setEditReferenceIdModalOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.customer);
        },
    });
    // Mutation for saving isCompany flag
    const saveIsCompanyMutation = useMutation(async (_isCompany) => {
        if (!customer) {
            throw new Error('No customer');
        }
        await customersAPI.patch(customer.customerId, {
            isCompany: _isCompany,
        });
        q.invalidate(keys.write.modify(customersEntity, customer.customerId));
        await ensureCustomerLoaded(customer.customerId);
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.customer);
        },
    });
    // Mutation for adding a new user to customer
    const addUserMutation = useMutation(async (userToAdd) => {
        if (!customer) {
            throw new Error('No customer');
        }
        const addedUser = await customersAPI.addUser(customer.customerId, userToAdd);
        q.invalidate(keys.write.modify(customersEntity, customer.customerId));
        await ensureCustomerLoaded(customer.customerId);
        if (userToAdd.contact && props.caseId) {
            await casesAPI.patch(props.caseId, {
                userOnCustomerId: addedUser.userOnCustomerId,
            });
            q.invalidate(keys.write.modify(casesEntity, props.caseId));
            await ensureCaseLoaded(props.caseId);
        }
    }, {
        onSuccess: () => {
            setAddCustomerModalOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.party);
        },
    });
    if (!customer) {
        return (React.createElement("div", null,
            React.createElement(PlaceholderLoader, null)));
    }
    const isMeCaseWorker = meRole && isCaseworker(meRole);
    const canAddUsers = site === Site.Caseworker && isMeCaseWorker;
    const erpLink = creditor && creditor.erpLink && customer.referenceId
        ? creditor.erpLink
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(CustomerStyled, null,
            React.createElement(HeaderStyled, null,
                React.createElement(ReferenceIdStyled, null,
                    customer.referenceId ? (React.createElement(CopyToClipboard, { text: customer.referenceId, iconStyle: {
                            margin: '0.2em 0.3em -0.2em -0.1em',
                            width: '16px',
                            height: '16px',
                        } }, customer.referenceId)) : (customer.referenceId),
                    site === Site.Caseworker && (React.createElement(Edit, { style: {
                            margin: '0em 0.3em 0em 0.1em',
                            width: '16px',
                            height: '16px',
                            cursor: 'pointer',
                        }, onClick: () => setEditReferenceIdModalOpen(!editReferenceIdModalOpen) })),
                    erpLink && (React.createElement(Link2, { style: {
                            margin: '0.2em 0.3em -0.2em 0.1em',
                            width: '16px',
                            height: '16px',
                            cursor: 'pointer',
                        }, onClick: () => {
                            if (erpLink && customer.referenceId) {
                                const url = erpLink.replace('{{customerReferenceId}}', customer.referenceId);
                                window.open(url, '_blank');
                            }
                        } }))),
                React.createElement(IsCompanyStyled, { onClick: () => {
                        if (!saveIsCompanyMutation.isLoading &&
                            site === Site.Caseworker) {
                            saveIsCompanyMutation.mutate(!isCompany);
                        }
                    }, disabled: site !== Site.Caseworker }, saveIsCompanyMutation.isLoading ? (React.createElement(PlaceholderLoader, { width: "90px", height: "17px" })) : (React.createElement(React.Fragment, null,
                    customer.isCompany ? (React.createElement("span", null,
                        React.createElement(Globe, { style: {
                                margin: '0.1em 0 -0.1em',
                            } }),
                        ' ',
                        lang.debtors.company)) : (React.createElement("span", null,
                        React.createElement(User, { style: {
                                margin: '0.1em 0 -0.1em',
                            } }),
                        ' ',
                        lang.debtors.private)),
                    site === Site.Caseworker && typeof isCompany === 'boolean' && (React.createElement(Repeat, { style: {
                            margin: '0.2em 0.3em -0.2em 0.4em',
                            width: '16px',
                            height: '16px',
                        } })))))),
            singleCase &&
                !customer.users.find((u) => u.userOnCustomerId === singleCase.userOnCustomerId) && (React.createElement(Alert, { style: { marginTop: '10px' }, message: lang.customers.noContactSelected, size: "small" })),
            React.createElement("div", { style: { marginBottom: '10px' } }, customer.users
                .sort((a, b) => a.id - b.id)
                .map((user) => (React.createElement(UserOnCustomer, { key: user.id, user: user, customer: customer, case: singleCase, selected: !!(props.selectedUserId && user.userId === props.selectedUserId), onClick: props.onClickOnUser, noPreview: props.noPreview })))),
            tenant && canAddUsers && (React.createElement(ButtonIcon, { value: lang.customers.addParty, onClick: () => {
                    setNewUser(getNewUser(tenant, true));
                    setAddCustomerModalOpen(!addCustomerModalOpen);
                } }))),
        addCustomerModalOpen && (React.createElement(Modal, { header: lang.customers.addParty, onToggle: () => setAddCustomerModalOpen(!addCustomerModalOpen) },
            tenantId &&
                APCOA_EI_TENANT_IDS.includes(tenantId) &&
                props.caseId && (React.createElement(APCOAAddDMRUser, { onSelect: (data) => {
                    if (newUser) {
                        // First update isCompany if needed, then add user
                        const addDMRUser = async () => {
                            if (data.isCompany !== customer.isCompany) {
                                await customersAPI.patch(customer.customerId, {
                                    isCompany: data.isCompany,
                                });
                            }
                            return {
                                contact: true,
                                details: {
                                    name: data.name,
                                    birthdate: data.birthdate,
                                    address: data.address,
                                    description: data.description,
                                    cvr: data.cvr,
                                },
                                lang: Lang.da,
                                relation: 'debtor',
                            };
                        };
                        addDMRUser().then((userToAdd) => {
                            addUserMutation.mutate(userToAdd);
                        });
                    }
                }, caseId: props.caseId })),
            newUser && (React.createElement(CreateUserOnCustomer, { user: newUser, isCompany: customer.isCompany, onDetailsChange: (c) => setNewUser({
                    ...newUser,
                    details: {
                        ...newUser?.details,
                        ...c,
                    },
                }), onChange: (c) => setNewUser({ ...newUser, ...c }) })),
            React.createElement(Button, { block: true, disabled: !(newUser &&
                    validateNewUserOnCustomer(customer, newUser).length === 0), onClick: () => {
                    if (newUser) {
                        addUserMutation.mutate(newUser);
                    }
                }, loading: addUserMutation.isLoading }, lang.customers.addParty))),
        editReferenceIdModalOpen && (React.createElement(Modal, { header: lang.customers.referenceId, onToggle: () => setEditReferenceIdModalOpen(!editReferenceIdModalOpen), maxWidth: "300px" },
            React.createElement(Input, { autofocus: true, placeholder: lang.customers.referenceId, value: referenceId, onChange: (e) => {
                    setReferenceId(e.target.value);
                }, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        saveReferenceIdMutation.mutate(referenceId);
                    }
                } }),
            React.createElement(Button, { loading: saveReferenceIdMutation.isLoading, onClick: () => {
                    saveReferenceIdMutation.mutate(referenceId);
                }, block: true }, lang.misc.save)))));
};
export default CustomerPreview;
const HeaderStyled = styled.div `
  margin: -19px 0 34px -3px !important;
  position: relative;
`;
const ReferenceIdStyled = styled.div `
  background: white;
  top: 0px;
  font-size: 14px !important;
  position: absolute;
  padding: 0 3px;

  & > div > span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
    display: inline-block;
  }
`;
const IsCompanyStyled = styled.div `
  background: white;
  top: 1px;
  right: 0px;
  font-size: 14px !important;
  position: absolute;
  padding: 0 3px;
  ${(props) => (props.disabled ? '' : 'cursor: pointer;')}
`;
const CustomerStyled = styled.div `
  border: 1px solid #efefef;
  border-radius: 3px;
  padding: 8px;
  margin: 10px 0 10px 0;
  position: relative;
`;
//# sourceMappingURL=CustomerPreview.js.map